import { fetchGroupsByIds } from 'utils/queries'

import { Program } from 'types/program'

import { useQuery } from './useQuery'

/// This will fetch all the Groups for provided Group Ids
export const useGroups = (groupIds: Array<string>) => {
  return useQuery<Array<Program | null>>(
    ['groups', ...groupIds],
    () => fetchGroupsByIds(groupIds),
    {
      enabled: groupIds.length > 0,
    },
  )
}
